import "./Add.css";
import Startbtn from "./Startbtn";
import Bar from "./Bar";
import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";

function Add({ name, date }) {
  const [startDate, setStartDate] = useState(new Date());
  const [food, setFood] = useState("양식");
  const [clock, setClock] = useState("11시");
  const array = ["양식", "한식", "일식", "중식", "기타"];
  const clocks = [
    "11시",
    "12시",
    "13시",
    "14시",
    "15시",
    "16시",
    "17시",
    "18시",
  ];

  return (
    <div className="background">
      <h1 className="main">{name}밥팟 신규등록</h1>
      <div className="script-wrapper">
        <div className="script">
          날짜:{" "}
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="script">
          시간:
          <select className="selects">
            {clocks.map((clock) => (
              <option value={clock} onChange={(clock) => setClock(clock)}>
                {clock}
              </option>
            ))}
          </select>
        </div>

        <div className="script">
          먹고 싶은 음식:
          <select className="selects">
            {array.map((item) => (
              <option value={item} onChange={(item) => setFood(item)}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="button">
        <Startbtn
          title="저장"
          date={startDate}
          food={food}
          clock={clock}
        ></Startbtn>
      </div>
      <div className="nav_bar5">
        <Bar></Bar>
      </div>
    </div>
  );
}

export default Add;
